import { theme } from '~/theme';

export const useSXStyles = () => {
  return {
    dialog: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateAreas: '"icon title actions close"',
      alignItems: 'center',
    },
    icon: {
      gridArea: 'icon',
      display: 'flex',
      marginRight: theme.spacing(1),
    },
    title: {
      gridArea: 'title',
    },
    actions: {
      gridArea: 'actions',
      display: 'flex',
      margin: theme.spacing(-1, -1, -1, 1),
    },
    actionsDivider: {
      height: '1em',
      alignSelf: 'center',
      margin: theme.spacing(0, 1),
    },
    close: {
      gridArea: 'close',
      margin: theme.spacing(-1, -1, -1, 1),
    },
  };
};
